/* eslint-disable camelcase */
import { useEffect } from "react";
import { useVCESValidate } from "@companion-core/shared/app/Queries";
import { useRegisterStore } from "@companion-core/shared/app/Store/registerStore";
import { trackClickRegister } from "@companion-core/shared/app/tracking/register";
import {
  APIVCESValidateResponse,
  APIVCESValidateResponseError,
} from "@companion-core/shared/app/Interfaces/API";

export const useVCESvalidator = () => {
  const { correlationId, setRegisterContent, setMemberToRegister, setRegisterError } =
    useRegisterStore((state) => ({
      correlationId: state.correlationId,
      setRegisterContent: state.setRegisterContent,
      setMemberToRegister: state.setMemberToRegister,
      setRegisterError: state.setRegisterError,
    }));
  const { mutateAsync: validatePan } = useVCESValidate();

  const checkVCESEligibility = async () => {
    if (!correlationId) return;
    try {
      const { data: validateResult }: APIVCESValidateResponse = await validatePan(correlationId);
      if (!validateResult?.result?.is_eligible) {
        setRegisterContent("register-member-not-found");
      } else {
        if (validateResult?.result?.is_datafeed) {
          setRegisterContent("vces-member-datafeed");
        } else {
          const member = validateResult?.result?.member;
          if (member) {
            if (member.has_email) {
              setMemberToRegister({
                memberId: member.id,
              });
              setRegisterContent("register-member-to-verify");
            } else {
              setMemberToRegister({
                memberId: member.id,
                eligibility_criteria: { correlation_id: correlationId },
              });
              setRegisterContent("register-no-email");
            }
          } else {
            setRegisterContent("vces-member-vces");
          }
        }
      }
    } catch (error: unknown) {
      const code = (error as APIVCESValidateResponseError)?.response?.data?.code;
      if (code === 408 || code === 409) {
        setRegisterError("already_registered");
        setRegisterContent("register-member-already-verified");
      } else if (code === 404) {
        setRegisterError("card_is_not_eligible");
        setRegisterContent("register-member-not-found");
      } else {
        setRegisterError("card_is_not_eligible");
        setRegisterContent("register-error");
      }
    }
  };

  useEffect(() => {
    checkVCESEligibility();
    trackClickRegister("vces_card_number_validate");
  }, [correlationId]);

  return {
    checkVCESEligibility,
  };
};
